var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitStep2Light(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 140,
    viewBox: "0 0 147 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 33.1797,
    fill: "#FF6B35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 125,
    width: 116,
    height: 15,
    fill: "#FFFAF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.864 140H18.7937C28.6737 74.83 111.324 85.47 111.324 42.34C111.324 28.85 101.254 18.97 84.5338 18.97C69.7138 18.97 59.2638 28.09 54.1337 37.78L42.7337 32.27C48.6237 19.16 63.2538 5.09999 85.8638 5.09999C108.664 5.09999 125.384 20.3 125.384 41.77C125.384 91.55 50.5238 88.7 38.1737 126.13H107.714L104.864 140Z",
    fill: "#FFFAF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitStep2Light);
export default __webpack_public_path__ + "static/media/digit_step_2_light.c0b096b4d3320f2658aeeb102f741430.svg";
export { ForwardRef as ReactComponent };